/* eslint-disable @typescript-eslint/no-explicit-any */
import Keycloak from 'keycloak-js'
const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM ?? '',
  url: process.env.REACT_APP_KEYCLOAK_URL ?? '',
  clientId: process.env.REACT_APP_KEYCLOAK_FRONTEND_CLIENT ?? '',
};

const _kc = new Keycloak(keycloakConfig);
/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback: () => void) => {
  _kc
    .init({
      checkLoginIframe: true,
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + process.env.PUBLIC_URL + '/silent-check-sso.html',
      pkceMethod: 'S256',
    })
    .then((authenticated) => {
      if (!authenticated || !isLoggedIn()) {
        console.warn('user is not authenticated..!')
        doLogin()
      }
      onAuthenticatedCallback()
    })
    .catch(console.error)
}

const doLogin = _kc.login

const doLogout = _kc.logout

const getToken = () => _kc.token

const getTokenParsed = () => _kc.tokenParsed

const isLoggedIn = () => !!_kc.token

_kc.onTokenExpired = () => {
  _kc
    .updateToken(5)
    .then(() => {})
    .catch(doLogin)
}

const isTokenGoingToExpire = (): boolean =>
  (_kc.tokenParsed?.exp || 0) + 60000 < Math.round(new Date().getTime() / 1000)

const updateToken = (successCallback: any): Promise<boolean | void> => {
  if (isTokenGoingToExpire()) {
    return _kc.updateToken(5).then(successCallback).catch(doLogin)
  }

  return Promise.resolve().then(successCallback)
}

const getUsername = () => {
  // console.log(_kc.tokenParsed)
  return _kc.tokenParsed?.preferred_username || _kc.tokenParsed?.name
}

const getEmail = () => {
  return _kc.tokenParsed?.email
}

const hasRole = (roles: string[]) => {
  let existRole = roles.some((role: string) => _kc.hasRealmRole(role))
  if (!existRole && _kc.tokenParsed)
    existRole = roles.some((role: string) => _kc.hasResourceRole(role, _kc.tokenParsed?.azp))
  return existRole
}

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  getUsername,
  getEmail,
  hasRole,
  isTokenGoingToExpire,
}

export default UserService
